class StickyAtcBar extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.mainAtcId = this.dataset.mainAtcId;
    this.mainAtc = document.getElementById(this.mainAtcId);
    this.stickyBtn = this.querySelector('[data-sticky-atc-button]');

    if (!this.mainAtc || !this.stickyBtn) return;

    this.variantPicker = document.querySelector('variant-radios, variant-selects');
    this.userPickedVariant = false;

    if (this.variantPicker) {
      const variantInputs = this.variantPicker.querySelectorAll('input, select');
      variantInputs.forEach((input) => {
        input.addEventListener('change', () => {
          this.userPickedVariant = true;
        });
      });
    }

    this.stickyBtn.addEventListener('click', (e) => {
      e.preventDefault();
      this.handleStickyClick();
    });

    this.checkViewport();
    window.addEventListener('resize', this.debounce(() => this.checkViewport(), 150));
  }

  handleStickyClick() {
    if (this.hasMultipleVariants() && !this.userPickedVariant && this.variantPicker) {
      this.variantPicker.scrollIntoView({ behavior: 'smooth', block: 'center' });
      this.variantPicker.classList.add('sticky-atc-highlight');
      setTimeout(() => {
        this.variantPicker.classList.remove('sticky-atc-highlight');
      }, 1600);
      return;
    }
    this.mainAtc.click();
  }

  hasMultipleVariants() {
    if (!this.variantPicker) return false;
    const radios = this.variantPicker.querySelectorAll('input[type="radio"]');
    if (radios.length > 1) return true;
    const selects = this.variantPicker.querySelectorAll('select');
    if (selects.length > 0) {
      const total = Array.from(selects).reduce((sum, sel) => sum + sel.options.length, 0);
      return total > 1;
    }
    return false;
  }

  checkViewport() {
    if (window.innerWidth >= 750) {
      this.stopObserver();
      return;
    }
    if (!this.observer) this.startObserver();
  }

  startObserver() {
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.classList.remove('sticky-atc--visible');
          this.setAttribute('aria-hidden', 'true');
        } else {
          this.classList.add('sticky-atc--visible');
          this.setAttribute('aria-hidden', 'false');
        }
      });
    }, { threshold: 0, rootMargin: '0px 0px -40px 0px' });

    this.observer.observe(this.mainAtc);
  }

  stopObserver() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
      this.classList.remove('sticky-atc--visible');
    }
  }

  debounce(fn, ms) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => fn.apply(this, args), ms);
    };
  }
}

if (!customElements.get('sticky-atc-bar')) {
  customElements.define('sticky-atc-bar', StickyAtcBar);
}